export default __webpack_public_path__ + "static/media/notfound.e4803bbf.png";